import { IPharmacyConsumableStock } from 'app/shared/model/pharmacy-consumable-stock.model';
import { IPharmacyConsumableBillItem } from 'app/shared/model/pharmacy-consumable-bill-item.model';
import { IPharmacyRefundBill } from 'app/shared/model/pharmacy-refund-bill.model';
import { IPharmacyBill } from 'app/shared/model/pharmacy-bill.model';
import { IPharmacyReturnBill } from 'app/shared/model/pharmacy-return-bill.model';
import { IPharmacyConsumableReturnBillItem } from 'app/shared/model/pharmacy-consumable-return-bill-item.model';

export interface IPharmacyConsumableRefundBillItem {
  id?: string;
  chargedMrp?: number;
  refundPaid?: number;
  refundQty?: number;
  soldQty?: number;
  manufacDate?: number;
  expDate?: number;
  active?: boolean;
  cursor?: number;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  pharmacyStock?: IPharmacyConsumableStock | null;
  saleBillItem?: IPharmacyConsumableBillItem | null;
  refundBill?: IPharmacyRefundBill | null;
  saleBill?: IPharmacyBill | null;
  returnBill?: IPharmacyReturnBill | null;
  returnItem?: IPharmacyConsumableReturnBillItem | null;
}

export const defaultValue: Readonly<IPharmacyConsumableRefundBillItem> = {
  active: false,
};
